import { createFileRoute } from "@tanstack/react-router";
import { PipelineEditPage } from "@client/components/doc-center/pipelines";

export const Route = createFileRoute("/_app/data-center/tmpl/edit/$id")({
  component: PipelineEditRoute,
});

function PipelineEditRoute() {
  const { id } = Route.useParams();
  return <PipelineEditPage id={id} />;
}
